
import { Card } from "ui/components/card";
import { Skeleton } from "ui/components/skeleton";

// Loading component that matches the actual content structure
export const PerformanceFeedbackLoader = ({ showReviewOf, showReviewBy }) => {
  return (
    <div className="flex-1 m-6 space-y-6">
      <div className="flex justify-end">
        <Skeleton className="h-10 w-10" />
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {showReviewOf && (
          <Card className="p-4 space-y-3">
            <Skeleton className="h-5 w-24" />
            <div className="flex items-center gap-3">
              <Skeleton className="h-12 w-12 rounded-full" />
              <div className="space-y-2">
                <Skeleton className="h-4 w-32" />
                <Skeleton className="h-3 w-24" />
              </div>
            </div>
          </Card>
        )}
        {showReviewBy && (
          <Card className="p-4 space-y-3">
            <Skeleton className="h-5 w-24" />
            <div className="flex items-center gap-3">
              <Skeleton className="h-12 w-12 rounded-full" />
              <div className="space-y-2">
                <Skeleton className="h-4 w-32" />
                <Skeleton className="h-3 w-24" />
              </div>
            </div>
          </Card>
        )}
      </div>

      {/* Performance sections skeleton */}
      <div className="space-y-3">
        {[1, 2, 3].map((index) => (
          <div key={index} className="space-y-3">
            <Skeleton className="h-6 w-48" />
            <Card className="flex !flex-row p-4 gap-4 items-start shadow-none">
              <div className="flex-shrink-0">
                <Skeleton className="h-16 w-16 rounded-full" />
              </div>
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 flex-1">
                {[1, 2, 3, 4, 5, 6].map((item) => (
                  <div key={item} className="space-y-2">
                    <Skeleton className="h-4 w-full" />
                    <Skeleton className="h-8 w-16" />
                  </div>
                ))}
              </div>
            </Card>
          </div>
        ))}
      </div>

      {/* Detailed feedback skeleton */}
      <div className="space-y-3">
        <Skeleton className="h-6 w-40" />
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {[1, 2, 3].map((item) => (
            <Card key={item} className="p-4 space-y-3">
              <Skeleton className="h-5 w-32" />
              <div className="space-y-2">
                <Skeleton className="h-4 w-full" />
                <Skeleton className="h-4 w-full" />
                <Skeleton className="h-4 w-3/4" />
              </div>
            </Card>
          ))}
        </div>
      </div>
    </div>
  );
};
